import {createSlice, PayloadAction} from "@reduxjs/toolkit";
import {ISocialStatusInitialState} from "../types";
import {IEntityWithIDTranslations} from "../../../../../../../types";
import {GetDeleteSocialStatus,GetSocialStatus} from "../store/thunk";

const initialState: ISocialStatusInitialState = {
    socialStatus: [],
    isSocialStatusRestore: false,
    socialStatusRestore:[],
    isLoadingSocialStatus:true,
    selectedSocialStatusIDs:[],
    filteredSocialStatus:[]
}

const socialStatusSlice = createSlice({
    name: "socialStatus",
    initialState,
    reducers:{
        setSocialStatus: (state, action: PayloadAction<{data:IEntityWithIDTranslations[],defaultLanguage:string}>) => {
            const {data,defaultLanguage} = action.payload;
            state.socialStatus= data
            state.filteredSocialStatus = data.flatMap(
                (data) => {
                    return data.translations
                        .filter((elem) => elem.slug === defaultLanguage)
                        .map((elem) => ({
                            id: data.id,
                            name: elem.name || "Unknown Name",

                        }));
                }
            );


        },
        deletedSocialStatus: (state, action: PayloadAction<number>) => {
            state.socialStatus= state.socialStatus.filter((elem) => elem.id !== action.payload);
        },
        updateSocialStatus: (state, action: PayloadAction<IEntityWithIDTranslations>) => {
            const updateData = action.payload;

            state.socialStatus = state.socialStatus.map((elem) => {
                if (elem.id === updateData.id) {
                    return {
                        ...elem,
                        ...updateData,
                    };
                }
                return elem;
            });
        },
        setSocialStatusRestore:(state, action) => {
            state.socialStatusRestore = action.payload;
        },
        setIsSocialStatusRestore:(state)=>{

            state.isSocialStatusRestore =!state.isSocialStatusRestore;
        },
        deletedRestoreSocialStatus:(state,action)=>{
            state.socialStatusRestore = state.socialStatusRestore.filter(
                (elem) => elem.id !== action.payload
            );
        },
        setSelectedSocialStatusIDs: (state, action) => {
            state.selectedSocialStatusIDs=action.payload
        },
    },
    extraReducers: (builder) => {
        builder
            .addCase(GetSocialStatus.pending, (state) => {
                state.isLoadingSocialStatus = true;
            })
            .addCase(GetSocialStatus.fulfilled, (state) => {
                state.isLoadingSocialStatus = false;
            })
            .addCase(GetSocialStatus.rejected, (state) => {
                state.isLoadingSocialStatus = false;
            })
            .addCase(GetDeleteSocialStatus.pending, (state) => {
                state.isLoadingSocialStatus = true;
            })
            .addCase(GetDeleteSocialStatus.fulfilled, (state) => {
                state.isLoadingSocialStatus = false;
            })
            .addCase(GetDeleteSocialStatus.rejected, (state) => {
                state.isLoadingSocialStatus = false;
            });
    },
})

export const {
    setIsSocialStatusRestore,
    setSelectedSocialStatusIDs,
    deletedRestoreSocialStatus,
    setSocialStatusRestore,
    deletedSocialStatus,
    updateSocialStatus,
    setSocialStatus
}=socialStatusSlice.actions;

export default socialStatusSlice